<template>
  <tr
    v-if="bluredOrNotHidden"
    :class="{ active: isActive, hovered: showActions }"
    class="draggableBlock"
    data-block="Raw"
    @mouseover="mouseOver"
    @mouseleave="mouseOut"
    @click.stop="() => click()"
  >
    <td
      :class="{
        'block-borders': showDragBorder,
        'dragged-opacity': isCurrentElementDragged,
      }"
      :style="{ padding: padding, backgroundColor: bgColor }"
      style="word-break: break-word"
      :align="align"
    >
      <blockActions
        v-if="showActions"
        :column-padding-x="columnPaddingX"
        :column-width="columnWidth"
        :disable-up-movement="disableUpMovement"
        :disable-down-movement="disableDownMovement"
        :block-height="blockHeight"
        :block-width="blockWidth"
        :is-active="isActive"
        :is-last-column="isLastColumn"
        :section-index="sectionIndex"
        :column-index="columnIndex"
        :block-index="blockIndex"
        :show-paste="showPaste"
        :copied="copied"
        @duplicate="copyBlock"
        @remove="deleteBlock"
        @moveUp="moveUp"
        @moveDown="moveDown"
        @copy="copyToClipboard"
      ></blockActions>
      <div :id="id">
        <table
          v-for="(element, i) in blockChildren"
          :key="i"
          role="presentation"
          cellpadding="0"
          cellspacing="0"
          style="float: none; display: inline-table"
          :align="align"
          border="0"
        >
          <tbody>
            <tr :style="hiddenStyle">
              <td style="padding: 4px; vertical-align: middle">
                <table
                  role="presentation"
                  cellpadding="0"
                  cellspacing="0"
                  :style="{ width: iconsize }"
                  style="background: none; border-radius: 3px"
                  border="0"
                >
                  <tbody>
                    <tr>
                      <td
                        style="vertical-align: middle"
                        :style="{
                          width: iconsize,
                          height: iconsize,
                          paddingLeft: block.attributes['icon-padding'],
                          paddingRight: block.attributes['icon-padding'],
                        }"
                      >
                        <a
                          :href="element.attributes['href']"
                          @click.stop.prevent="() => click()"
                        >
                          <img
                            :key="element.attributes['src']"
                            :alt="element.attributes['alt']"
                            :height="iconsize.replace('px', '')"
                            :src="element.attributes['src']"
                            style="display: block; border-radius: 3px"
                            :width="iconsize.replace('px', '')"
                        /></a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </td>
  </tr>
</template>

<script lang="ts" setup>
  import blockProperties from "@/composables/useBlockProperties";
  import blockActions from "./blockActions.vue";

  import { computed } from "vue";

  const props = defineProps<{
    block: any;
    columnIndex: number;
    sectionIndex: number;
    blockIndex: number;
    isLocked: boolean;
  }>();

  const {
    showActions,
    showPaste,
    blockHeight,
    blockWidth,
    id,
    bluredOrNotHidden,
    hiddenStyle,
    isActive,
    disableUpMovement,
    disableDownMovement,
    columnPaddingX,
    columnWidth,
    isCurrentElementDragged,
    showDragBorder,
    isLastColumn,
    copied,
    mouseOver,
    mouseOut,
    click,
    copyBlock,
    deleteBlock,
    moveUp,
    moveDown,
    copyToClipboard,
  } = blockProperties(props);

  const align = computed(() => {
    return props.block.attributes["align"]
      ? props.block.attributes["align"]
      : "center";
  });

  const padding = computed(() => {
    if (props.block.attributes["padding"]) {
      return props.block.attributes["padding"];
    }

    return "10px 25px 10px 25px";
  });

  const iconsize = computed(() => {
    if (props.block.attributes["icon-size"]) {
      return props.block.attributes["icon-size"];
    }

    return "35px";
  });

  const bgColor = computed(() => {
    const bgColor = props.block.attributes["container-background-color"];
    if (bgColor !== null || bgColor !== undefined) {
      return bgColor;
    }

    return "";
  });

  const blockChildren = computed(() => {
    return props.block.children
      ? props.block.children.filter(
          (child: any) =>
            typeof child === "object" && typeof child.attributes === "object"
        )
      : [];
  });
</script>
